module.exports = __webpack_public_path__ + "public/img/暂停.655fa27a.svg";